import { casinoStoreKeys } from '../casinoStoreConstants'
import { useSetCasinoData } from '../hooks'

export const useSetCasinoIsPhone = () => {
  const { setCasinoData } = useSetCasinoData()

  const setCasinoIsPhone = casinoIsPhone => {
    setCasinoData({ [casinoStoreKeys.casinoIsPhone]: casinoIsPhone }, 'setCasinoIsPhone')
  }
  return { setCasinoIsPhone }
}
